import React from 'react'
import Head from 'next/head'
import { SeoProps } from '~types'
import { BASE_URLS, isProd } from '~constants'
import { usePathname } from 'next/navigation'

const SEO = ({
  allowSearchEnginesToShowThisPage,
  defaultTitle,
  ogImage,
  metaDescription,
  seoTitle,
  shouldSearchEnginesFollowLinks,
  ogTitle,
  ogType,
  ogDescription,
  canonicalUrl
}: SeoProps) => {
  const pathName = usePathname()
  const appUrl = process.env.NEXT_PUBLIC_DOMAIN_URL || BASE_URLS.prod

  const pageTitle = seoTitle || `${defaultTitle} | Sphere`
  const robotsValues = []
  const robotsIndex = allowSearchEnginesToShowThisPage && isProd ? 'index' : 'noindex'
  const robotsFollow = shouldSearchEnginesFollowLinks && isProd ? 'follow' : 'nofollow'
  const pageUrl = `${appUrl}${pathName}`

  robotsValues.push(robotsIndex)
  robotsValues.push(robotsFollow)

  // Use canonicalUrl if provided, otherwise fallback to generated pageUrl
  // strip trailing slash from canonical so it matches browser and sitemap url
  const finalCanonicalUrl = (canonicalUrl || pageUrl).replace(/\/+$/, '')

  return (
    <Head>
      <title>{pageTitle}</title>
      {metaDescription && <meta name='description' content={metaDescription} />}
      <meta name='robots' content={robotsValues.join(', ')} />
      <link rel='canonical' href={finalCanonicalUrl} />
      <meta property='og:url' content={finalCanonicalUrl} />
      <meta property='og:type' content={ogType || 'website'} />
      <meta property='og:title' content={ogTitle || pageTitle} />
      <meta property='og:description' content={ogDescription || metaDescription} />
      {ogImage && ogImage.url && <meta property='og:image' content={ogImage.url} />}
    </Head>
  )
}

export default SEO
